import { useAppStore } from "@hooks/useAppStore";
import type { LogoConfigSchemaType } from "@memorang/constants/config/schema";
import { useMemo } from "react";
import { useExamBranding } from "./useExamBranding";

export const useAppLogo = (): LogoConfigSchemaType => {
	const branding = useExamBranding();
	const appLogo = useAppStore((store) => store.app.logo);

	return useMemo(() => {
		if (!branding?.logo) {
			return appLogo;
		}
		return {
			...appLogo,
			default: branding.logo.default ?? appLogo.default,
			stacked: branding.logo.stacked ?? appLogo.stacked,
		};
	}, [branding, appLogo]);
};
